import { render, staticRenderFns } from "./DiscountCode.page.vue?vue&type=template&id=2f8f8fb5&scoped=true&"
import script from "./DiscountCode.page.vue?vue&type=script&lang=js&"
export * from "./DiscountCode.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f8fb5",
  null
  
)

export default component.exports